import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { useGetPaginatedQuery } from '../../../store/api/endpoints/clientesApiSlice'
import { getUsuarioPermisos } from '../../../store/slices/auth'

import HeaderVista from '../../elementos/HeaderVista'
import TablaPaginada2026 from '../../elementos/TablaPaginada2026'
import ButtonIcon from '../../elementos/ButtonIcon'

import AddIcon from '@mui/icons-material/Add'
import PeopleAltIcon from '@mui/icons-material/PeopleAlt'
import SearchIcon from '@mui/icons-material/Search'
import { Breadcrumbs, Typography } from '@mui/material'

export default function Clientes() {
    const permisosDelUsuario = useSelector(getUsuarioPermisos)

    // 1. Definición de columnas con useMemo
    const thead = useMemo(() => [
        { label: "Alta", align: "center", ordenable: true },
        { label: "Tipo", align: "left", ordenable: true },
        { label: "Marca", align: "left", ordenable: true },
        { label: "Dominio", align: "left", ordenable: true },
        { label: "Nombre", align: "left", ordenable: true },
        { label: "Email", align: "left", ordenable: true },
        { label: "Teléfono", align: "left", ordenable: true },
        { label: "Acciones", align: "center", ordenable: false }
    ], [])

    // 2. Definición de cuerpo de tabla con useMemo
    const tbody = useMemo(() => [
        { tipo: "fecha", valor: "alta" },
        { tipo: "texto", valor: "tipo_app" },
        { tipo: "texto", valor: "marca" },
        { tipo: "texto", valor: "dominio" },
        { tipo: "texto", valor: "nombre" },
        { tipo: "texto", valor: "email" },
        { tipo: "texto", valor: "telefono" },
        {
            tipo: "botones",
            valor: [
                {
                    color: "primary",
                    icono: <SearchIcon />,
                    ruta: "/clientes/", // La tabla concatenará el _id al final
                    valor: '_id'
                }
            ]
        }
    ], [])

    // 3. Control de acceso
    if (!permisosDelUsuario.includes(3)) {
        return <>No tienes acceso a visualizar los clientes.</>
    }

    return (
        <>
            <HeaderVista
                titulo={
                    <Breadcrumbs aria-label="breadcrumb">
                        <Typography color="text.primary">Clientes</Typography>
                    </Breadcrumbs>
                }
                icon={<PeopleAltIcon />}
                end={
                    permisosDelUsuario.includes(9) && (
                        <ButtonIcon
                            variant="outlined"
                            size="small"
                            color="primary"
                            startIcon={<AddIcon />}
                            to="/clientes/crear"
                        >
                            Nuevo
                        </ButtonIcon>
                    )
                }
            />
            <TablaPaginada2026
                api={useGetPaginatedQuery}
                thead={thead}
                tbody={tbody}
                orderDefault={[0, 1]} // Orden por Fecha Alta descendente
            />
        </>
    )
}